/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import MultipleSelect from '$components/MultipleSelect/MultipleSelect';

import {
  SelectContainer,
  SelectWrapper,
} from './AssessmentItemSelector.styled';

const AssessmentItemSelector = ({
  selectOptions,
  selectedAssessmentItem,
  onSelectorChange,
  selectedOptions,
  disabled,
}) => {
  const { id } = selectedAssessmentItem;

  return (
    <SelectWrapper>
      <SelectContainer>
        <MultipleSelect
          id={id}
          item="assessment-item"
          options={selectOptions}
          selectedOptions={selectedOptions}
          handleChange={onSelectorChange}
          disabled={disabled}
        />
      </SelectContainer>
    </SelectWrapper>
  );
};

AssessmentItemSelector.propTypes = {
  selectOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedAssessmentItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onSelectorChange: PropTypes.func.isRequired,
  selectedOptions: PropTypes.arrayOf(PropTypes.string),
  disabled: PropTypes.bool,
};

AssessmentItemSelector.defaultProps = {
  selectedOptions: [],
  disabled: false,
};

export default AssessmentItemSelector;
